

















import { defineComponent, computed, ref } from '@vue/composition-api';
import { windowHelper } from '@tencent/ppd-base-libs';
import { storeToRefs } from 'pinia';
import { useStampStore } from '@/store/stamp';
import AddSubtractNum from '@/components/add-subtract-num/index.vue';
import DonationBtn from '@/components/donation-btn/index.vue';
import { biClick } from '@tencent/fit-bi-sdk';

export default defineComponent({
  name: 'BottomDonate',
  components: {
    AddSubtractNum,
    DonationBtn,
  },
  props: {
    item: {
      reuqired: true,
      type: Object,
      default: () => ({ key: '' }),
    },
  },
  setup(props, { emit }) {
    const stampStore = useStampStore();
    const { userStampInfo } = storeToRefs(stampStore);
    const maxNum = computed(() => userStampInfo.value.intervalAvailableCnt || 1);
    const currentNum = ref(1);
    const addSubtractNum = ref<InstanceType<typeof AddSubtractNum> | null>(null);
    return {
      addSubtractNum,
      maxNum,
      currentNum,
      userStampInfo,
      goCharity() {
        windowHelper.redirect('', 300);
      },
      allDonate() {
        if (userStampInfo.value.intervalAvailableCnt > 0) {
          currentNum.value = userStampInfo.value.intervalAvailableCnt;
        }
        biClick('bottom-donate.all_donate_click|全部捐赠点击');
      },
      numChange(num) {
        props.item.donateCount = num;
      },
      donationComplete() {
        addSubtractNum.value?.setCurrentNum(1);
      },
      donationSucc(ngo) {
        emit('donationSucc', ngo);
      },
    };
  },
});
